import React, { useEffect, useState } from "react";
import "./patientFullView.css";
import { useTranslation } from "react-i18next";
import Widgets from "../../widgets";

const PatientIdView = ({ data }) => {
  const { t } = useTranslation();
  const [processedData, setProcessedData] = useState([]);

  useEffect(() => {
    if (!data) return;
    setProcessedData(data);
  }, [data]);

  return (
    <div className="piv-container">
      <p className="piv-title">{t("nationalIdInfo")}</p>
      {processedData?.map((item, i) => (
        <div className="piv-section" key={i}>
          <div className="piv-id nat-id piv-id-number">
            <div className="piv-id">
              <p className="piv-subtitle">{t("idType")}</p>
              <p className="piv-number">{item?.category?.title}</p>
            </div>
            <div className="piv-id">
              <p className="piv-subtitle">{t("idNumber")}</p>
              <p className="piv-number">{item?.number}</p>
            </div>
          </div>

          <div className="piv-images">
            {item?.images?.front && (
              <div className="piv-img-box">
                <p>{t("frontNatioalId")}</p>
                <Widgets.SelectCard image={item.images.front} idType={"frontNatioalId"} front disabled />
              </div>
            )}
            {item?.images?.back && (
              <div className="piv-img-box">
                <p>{t("backNatioalId")}</p>
                <Widgets.SelectCard image={item.images.back} idType={"backNatioalId"} front disabled />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PatientIdView;
